import React from 'react';
import {ToggleWrapper} from "./ToggleWrapper";
import {ToggledFeature} from "./featureToggleService";

export function GoogleSignInToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.GOOGLE_SIGNIN}>
      {props.children}
    </ToggleWrapper>
  );
}
